// extracted by mini-css-extract-plugin
module.exports = {"mobileCountdownHolder":"MobileEventCountdown_mobileCountdownHolder__FJkMl","itemHolder":"MobileEventCountdown_itemHolder__Hj7g8"};